/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_246" data-name="Rectangle 246" width="100%" height="100%" transform="translate(0)" fill="none" stroke="#fff" stroke-width="1"/>
    </clipPath>
  </defs>
  <g id="Group_2274" data-name="Group 2274" clip-path="url(#clip-path)">
    <g id="Group_3228" data-name="Group 3228" transform="translate(4.875 3.931)">
      <rect id="Rectangle_245" data-name="Rectangle 245" width="15.054" height="2.651" rx="1" transform="translate(0 20.794)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
      <path id="Path_1060" data-name="Path 1060" d="M24.717,112.862v-1.02a1.887,1.887,0,0,0-1.887-1.887H15.694a1.887,1.887,0,0,0-1.887,1.887v1.02" transform="translate(-11.735 -92.22)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
      <path id="Path_1061" data-name="Path 1061" d="M34.835,14.574,32.9,12.635a1.985,1.985,0,0,1,0-2.807l7.4-7.4a1.985,1.985,0,0,1,2.807,0L45.04,4.369a1.985,1.985,0,0,1,0,2.807l-7.4,7.4A1.985,1.985,0,0,1,34.835,14.574Z" transform="translate(-29.035 -1.849)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
      <path id="Path_1062" data-name="Path 1062" d="M80.763,48.463,90.5,57.91a.257.257,0,0,1,0,.366l-1.8,1.8a.257.257,0,0,1-.365,0l-9.462-9.722" transform="translate(-67.526 -40.385)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
      <line id="Line_90" data-name="Line 90" x2="4.659" y2="4.659" transform="translate(4.914 6.954)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
      <line id="Line_91" data-name="Line 91" x2="4.468" y2="4.467" transform="translate(10.414 1.634)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
    </g>
  </g>
</svg>
`

const AuctionSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}
export default AuctionSvg
